export enum Flipper {
  emergingBrandsPortal = 'rt_emerging_brands_portal',
}
